module.exports = __webpack_public_path__ + "img/icon-find-store-w.0c5ee4a5.svg";